import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/global/LoadingSpinner';
import { useQuery } from '@tanstack/react-query';
import { getCurrentBusinessConfig } from '../firebase/firebase-delegate';
import { useAdminData } from '../contexts/AdminDataContext';

interface OwnerOnlyProps {
    element: JSX.Element;
}

const OwnerOnlyRoute: React.FC<OwnerOnlyProps> = ({ element }) => {

    const { currentEmployeeQuery: employeeQuery } = useAdminData();

    const businessConfigQuery = useQuery({
        queryKey: ['businessConfig'],
        queryFn: () => getCurrentBusinessConfig(),
        enabled: employeeQuery.isSuccess
    });

    const isLoading = employeeQuery.isLoading || businessConfigQuery.isLoading;
    const isError = employeeQuery.isError || businessConfigQuery.isError;

    if (isLoading || businessConfigQuery.isLoading) {
        return <LoadingSpinner />;
    }

    const isOwner =
        businessConfigQuery.data?.paymentInfo?.owner === employeeQuery.data?.id;
    console.log("isOwner", isOwner, "owner: ", businessConfigQuery.data?.paymentInfo?.owner, "id: ", employeeQuery.data?.id);

    if (isError || !isOwner) {
        return <Navigate to="/admin" replace />;
    }

    return element;
};

export default OwnerOnlyRoute;
